module.exports = __webpack_public_path__ + "static/media/disc_2x.f8597504.png";